import { useEffect, useState } from 'react';
import { BACKEND_URL } from '@/lib/backendUrl';

export function useRealTestimonials({ segmento, uf } = {}) {
  const [itens, setItens] = useState([]);
  useEffect(() => {
    const params = new URLSearchParams();
    if (segmento) params.set('segmento', segmento);
    if (uf) params.set('uf', uf);
    fetch(`${BACKEND_URL}/api/public/testimonials?${params.toString()}`)
      .then((r) => (r.ok ? r.json() : { itens: [] }))
      .then((d) => setItens(d.itens || []))
      .catch(() => setItens([]));
  }, [segmento, uf]);
  return itens.map((t) => ({ nome: t.nome, negocio: t.negocio, cidade: `${t.cidade}/${t.uf}`, texto: t.texto, logo: t.logo_url }));
}
